export default __webpack_public_path__ + "static/media/InfoMsg.1bf5ad10.png";